import React from 'react';
import PropTypes from 'prop-types';

const BasemapSelector = props => {
  const { selected, handleClick } = props;

  return (
    <div className="BasemapSelector">
      <button
        onClick={() => handleClick('detailmap')}
        className={selected === 'detailmap' ? 'active' : ''}
      >
        Placemarked
      </button>
      <button
        onClick={() => handleClick('watercolor')}
        className={selected === 'watercolor' ? 'active' : ''}
      >
        Watercolor
      </button>
    </div>
  );
};

BasemapSelector.propTypes = {
  selected: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default BasemapSelector;



// WEBPACK FOOTER //
// ./src/components/BasemapSelector.jsx